module.exports = __webpack_public_path__ + "static/media/dmun.e52220ff.png";